import compileInvalidFormField from '../util/invalid_form_field'

up.compiler('[validate-acceptance]', (element) => {
  const form = element.closest('form')

  form.addEventListener('submit', function(event) {
    if (!element.checked) {
      event.preventDefault()
      element.classList.add('is-invalid')
      compileInvalidFormField(element)
    }
  })
})
